import { NgModule } from '@angular/core';
import { RouterModule, Routes, NoPreloading } from '@angular/router';
import { AuthGuardService } from './services/auth-guard/auth-guard.service';
import { InitAuthGuardService } from './services/init-auth-guard/init-auth-guard.service';
import { NGXLogger } from 'ngx-logger';

const routes: Routes = [
  { path: '', redirectTo: 'global-menu/tabs/tabs', pathMatch: 'full' },
  { path: 'login', redirectTo: 'global-menu/tabs/tabs/auth/login', pathMatch: 'full' },

  { 
    path: 'global-menu', 
    canActivate: [InitAuthGuardService], 
    loadChildren: () => import('./pages/global-menu/global-menu.module').then(m => m.GlobalMenuPageModule) 
  },
  { 
    path: 'alerteDetail/:idAlerte/:idNotif', 
    canActivate: [AuthGuardService], 
    loadChildren: () => import('./pages/alerte-detail/alerte-detail.module').then(m => m.AlerteDetailPageModule) 
  },
  { 
    path: 'bandeau/:idIntervention', 
    loadChildren: () => import('./pages/bandeau/bandeau.module').then(m => m.BandeauPageModule) 
  },
  { 
    path: 'alerte-detail/:idAlerte', 
    loadChildren: () => import('./pages/alerte-detail/alerte-detail.module').then(m => m.AlerteDetailPageModule) 
  },
  { 
    path: 'alerte-detail/:idAlerte/alerte-statut', 
    loadChildren: () => import('./pages/alerte-statut/alerte-statut.module').then(m => m.AlerteStatutPageModule) 
  },
  { 
    path: 'alerte-detail/:idAlerte/image-zoom', 
    loadChildren: () => import('./pages/image-zoom/image-zoom.module').then(m => m.ImageZoomPageModule) 
  },
  { 
    path: 'cgu', 
    loadChildren: () => import('./pages/cgu/cgu.module').then(m => m.CguPageModule) 
  },
  { 
    path: 'alerte-detail/:idAlerte/:idNotif', 
    loadChildren: () => import('./pages/alerte-detail/alerte-detail.module').then(m => m.AlerteDetailPageModule) 
  },
  { 
    path: 'alerte-detail/:idAlerte/:idNotif/alerte-statut', 
    loadChildren: () => import('./pages/alerte-statut/alerte-statut.module').then(m => m.AlerteStatutPageModule) 
  },
  { 
    path: 'alerte-detail/:idAlerte/:idNotif/image-zoom', 
    loadChildren: () => import('./pages/image-zoom/image-zoom.module').then(m => m.ImageZoomPageModule) 
  },
  { 
    path: 'reset-password', 
    loadChildren: () => import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule) 
  },
  { 
    path: 'privacy-policy', 
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule) 
  },
  { 
    path: 'usr-mgmt', 
    loadChildren: () => import('./pages/usr-mgmt/usr-mgmt.module').then(m => m.UsrMgmtPageModule) 
  },
  { 
    path: 'manage-account', 
    loadChildren: () => import('./pages/manage-account/manage-account.module').then(m => m.ManageAccountPageModule) 
  },
  { 
    path: 'update-password', 
    loadChildren: () => import('./pages/update-password/update-password.module').then(m => m.UpdatePasswordPageModule) 
  },
  { 
    path: 'tutorial', 
    loadChildren: () => import('./pages/tutorial/tutorial.module').then(m => m.TutorialPageModule) 
  },
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

 
  constructor(
    private logger: NGXLogger){
      this.logger.debug(routes);
      this.logger.debug('The Ionic Error is in this file');

    }
 }
